var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssistant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272.377,
    height: 178.53,
    viewBox: "0 0 272.377 178.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M0,0H223.967l-12,150.758S192.88,178.679,115.6,178.53,11.421,143.67,11.421,143.67Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -93.499,
    y1: 0.46,
    x2: -92.636,
    y2: 0.46,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(-1523.015 -764.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M236.823,1092.534s-65.529-16.914-53.265,57.074,85.752,80.642,85.752,80.642S418.221,1256.408,427,1158.368s-80.379-91.567-80.379-91.567-31.263,2.478-41.388,20.508S236.823,1092.534,236.823,1092.534Z",
    transform: "translate(1340.986 -290.776)",
    fill: "#bdc4d5",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(1534.522 764.201)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(2.523 -10.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1614.563,477.973q-.089.215-.169.442C1614.433,478.326,1614.488,478.175,1614.563,477.973Z",
    transform: "translate(-1528.784 -444.71)",
    fill: "#98bdf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M1614.3,479.794c-.022.061-.033.095-.033.095A.423.423,0,0,1,1614.3,479.794Z",
    transform: "translate(-1528.681 -446.089)",
    fill: "#98bdf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M1477.063,474.178c.274-.436,7.95-10.018,7.173-10.912-.527-.606-1.641-.262-2.342.047a.211.211,0,0,1-.264-.3l1.028-1.742a.2.2,0,0,0,.027-.068.517.517,0,0,0-.51-.613c-1.56.068-4.305,2.547-5.749,3.959a.21.21,0,0,1-.333-.245l1.239-2.453a.184.184,0,0,0-.162-.264c-3.748-.179-14.145,11.877-16.273,14.392a.21.21,0,0,1-.366-.1c-.485-2.562-1.948-9.314-4-9.143-2.462.206-3.666,21.035-3.732,22.21a.2.2,0,0,1-.031.1l-4.089,6.692a.21.21,0,0,1-.219.1c-1.5-.282-2.423-.358-2.423-.358l-5.551,9.214a.209.209,0,0,1-.374-.034q-.194-.5-.387-.994c-1.145-2.947-2.262-5.791-3.266-8.478a29.451,29.451,0,0,0-5.7-9.4.205.205,0,0,1,.028-.3A6.211,6.211,0,0,0,1432,484.3c2.1-2.727,1.735-7.5-6.859-14.445-16.722-13.508-11.5-16.474-13.833-28.285-2.324-11.788-8.7-21.986-18.747-20.467a.2.2,0,0,1-.094-.008,19.227,19.227,0,0,0-11.915-.358v-.005c-11.445.343-16.29,10.8-17.288,13.308a9.564,9.564,0,0,1,1.55-2.507.21.21,0,0,1,.355.21c-2.571,7.182-.015,10.454.48,11a.206.206,0,0,0,.188.069l.173-.031a.206.206,0,0,1,.247.206c0,.627.006,1.27.04,1.9a.192.192,0,0,1,0,.047,53.232,53.232,0,0,1-3.53,11.928,20.573,20.573,0,0,1-3.777,6.15c-9.645,9.7-9.566,21.983,2.008,21.314a36.159,36.159,0,0,1,6.968.21.206.206,0,0,1,.166.282c-1.714,4.42-7.445,19.473-11.691,33.532a.206.206,0,0,1-.142.137l-2.346.672a3.211,3.211,0,0,0-2.33,3.084v1.842a.205.205,0,0,1-.211.21c-1.486-.021-10.494-.179-17.934-.992l-4.773-.671c-.343-.063-.672-.128-.991-.194,0,0-.015.017-.038.049l-11.872-1.672a.207.207,0,0,1-.147-.093l-4.695-7.236a.21.21,0,0,0-.06-.062l-7.771-5.11a.21.21,0,0,0-.315.11l-.719,2.2a.209.209,0,0,0,.049.211l3.421,3.523a.221.221,0,0,1,.056.108l.062.333a.21.21,0,0,1-.222.247l-5.424-.4a.18.18,0,0,1-.05-.01l-5.271-1.717a.132.132,0,0,1-.034-.016l-6.463-3.477a.2.2,0,0,0-.159-.016,1.734,1.734,0,0,0-1.158,2,.211.211,0,0,0,.082.147l.707.541a.21.21,0,0,1-.226.351l-2.613-1.408a.212.212,0,0,0-.16-.016,1.735,1.735,0,0,0-1.158,2,.211.211,0,0,0,.083.147l1.54,1.179-.72-.388a.21.21,0,0,0-.159-.016,1.734,1.734,0,0,0-1.158,2,.206.206,0,0,0,.082.147l2.278,1.744a.209.209,0,0,1-.01.343,1.8,1.8,0,0,0-.7,1.774.209.209,0,0,0,.082.147l6.536,5a.227.227,0,0,0,.063.034l8.574,2.795.026.006,12.735,2.471.069-.094,9.745,3.108a.206.206,0,0,1,.137.25,47.114,47.114,0,0,0-1.174,14.439.21.21,0,0,0,.387.1,35.608,35.608,0,0,0,3.607-8.116,35.346,35.346,0,0,1-1.234,3.711,20.9,20.9,0,0,1-2.544,4.7.21.21,0,0,0,.093.323c2.935,1.1,29.717,10.984,39.055,7.073q1.2-.5,2.233-1.028a.209.209,0,0,1,.3.176c.121,2.4.206,3.916.212,4.048v.021l-3.862,83.908a.205.205,0,0,0,.082.176,25.041,25.041,0,0,0,10.538,4.074.206.206,0,0,1,.175.2q.025.785.056,1.576c.186,4.8,2.078,24.073,3.984,42.7H1392.3c.48-8.87.9-16.914,1.1-21.275.448-9.826-3.369-18.262-5.444-22.075a6.709,6.709,0,0,1-.624-4.825c.251-1,.538-2.148.79-3.161a.206.206,0,0,1,.206-.158h2.932a.21.21,0,0,1,.206.179l1.883,12.546a7.854,7.854,0,0,0,.6,2.042l16.462,36.729h19.06c-1.151-9.937-3.542-21.635-8.5-28.985-3.984-5.905-6.648-10.2-8.414-13.236a11.891,11.891,0,0,1-1.214-2.93.211.211,0,0,1,.172-.261c10.923-1.645,20.177-4.486,24.729-7.106,1.576-.907,2.591-1.55,2.912-1.757a.21.21,0,0,0,.094-.2c-2.308-19.478-4.8-42.687-6.608-60.023-.882-8.455-1.6-15.514-2.067-20.062a.206.206,0,0,1,.163-.223c33.718-7.613,36.279-51.791,36.279-51.791h0a28.61,28.61,0,0,0-5.9-4.642.212.212,0,0,1-.089-.249l1.933-5.477a.2.2,0,0,1,.04-.069l1.751-1.977a.213.213,0,0,1,.078-.054,63.427,63.427,0,0,0,6.934-3.381,11.061,11.061,0,0,0,2.35-2.261c4.533-5.349,9.306-16.348,9.873-17.676a.206.206,0,0,0-.056-.24C1482.278,467.793,1477.262,473.93,1477.063,474.178Z",
    transform: "translate(-1277.859 -400.767)",
    fill: "#98bdf9",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M1767.417,1328.353h-18.511l-16.224-36.2a25.313,25.313,0,0,1-1.935-6.6l-3.789-25.232,25.753,7.707.115.034-2.536,4.446a11.992,11.992,0,0,0,.035,11.969c1.766,3.033,4.43,7.333,8.412,13.236C1763.97,1305.47,1766.341,1318.087,1767.417,1328.353Z",
    transform: "translate(-1614.037 -1037.255)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M1672.74,1322.748c-.21,4.631-.672,13.415-1.19,22.934h-17.393c-1.961-19.121-3.962-39.412-4.154-44.354-.354-9.1-.047-18.127-.047-18.127l11.868,4.462,6.293,2.365c-.137.569-.877,3.556-1.446,5.82a6.717,6.717,0,0,0,.624,4.824C1669.375,1304.484,1673.192,1312.921,1672.74,1322.748Z",
    transform: "translate(-1555.625 -1054.584)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M1698.519,1336.679c-.209,4.631-.672,13.415-1.19,22.934h-5.84c-.305-17.393-1.707-34.061-4.4-38.825-6-10.59-1.768-17.3-1.768-17.3l2.286-1.894,6.293,2.365c-.137.57-.877,3.556-1.446,5.821a6.715,6.715,0,0,0,.624,4.825C1695.147,1318.416,1698.964,1326.852,1698.519,1336.679Z",
    transform: "translate(-1581.4 -1068.514)",
    fill: "#f9b393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M1453.951,836s-7.438,9.033-6.11,26.3C1447.844,862.3,1454.752,852.739,1453.951,836Z",
    transform: "translate(-1402.516 -715.878)",
    fill: "#3b2bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M1436.817,832.414,1413.99,829.2l-3.072,9.428,29.2,9.314,3.807-7.079Z",
    transform: "translate(-1374.668 -710.728)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M1384.06,792.1l-2.5-2.081-4.909-7.568-8.038-5.286-.843,2.586,3.553,3.66,1.814,9.819,10.032,3.27Z",
    transform: "translate(-1341.989 -671.319)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M1357.578,803.8l-11.357-.828,3.2,13.521,12.747,2.474,3.636-5.261Z",
    transform: "translate(-1325.671 -690.858)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M1320.495,789.33l-1.772-1.706-5.667-1.85-6.552-3.527a1.738,1.738,0,0,0-1.234,2.117l6.637,5.076,8.62,2.81Z",
    transform: "translate(-1294.637 -675.164)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M1306.61,796l-1.772-1.706-5.666-1.85-6.552-3.527a1.738,1.738,0,0,0-1.234,2.117l6.637,5.076,8.62,2.81Z",
    transform: "translate(-1284.119 -680.216)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1304.9,808.046l-1.772-1.706-5.666-1.847-6.552-3.527a1.738,1.738,0,0,0-1.234,2.117l6.637,5.076,8.621,2.81Z",
    transform: "translate(-1282.821 -689.342)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1311.7,824.543l-.244-5.3-7.2,1.742-6.552-3.527a1.738,1.738,0,0,0-1.234,2.117l6.637,5.076,8.62,2.81Z",
    transform: "translate(-1287.973 -701.84)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1498.979,738.184s-1.439,5.67-11.325,9.809-39.318-7.173-39.318-7.173a20.525,20.525,0,0,0,2.714-4.923c3.579-8.939,3.4-21.377,3.4-21.377,8.01,1.693,23.909,1.861,23.909,1.861v-2.056a3.209,3.209,0,0,1,2.326-3.084l2.457-.7c5.047-16.736,12.226-34.929,12.226-34.929l.617,6.521Z",
    transform: "translate(-1403.012 -594.397)",
    fill: "#5846f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1498.979,751.377s-1.439,5.67-11.325,9.809-39.318-7.173-39.318-7.173a20.546,20.546,0,0,0,2.714-4.923c10.05.636,29.916.681,35.484-8.227,7.553-12.081,7.545-47.836,7.545-47.836l1.9,2.3Z",
    transform: "translate(-1403.012 -607.588)",
    fill: "#3b2bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1607.322,542.423c-9.092,2.61-9.531-4.414-24.651-3.545-11.574.665-11.651-11.615-2.007-21.317a20.527,20.527,0,0,0,3.776-6.15,59.751,59.751,0,0,0,4.285-17.381L1605.64,514.7l2.721,3.325S1619.665,538.88,1607.322,542.423Z",
    transform: "translate(-1497.951 -456.871)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M1630.294,536.159s1.325-8.419-7.895-14.13c-3.951-2.446-4.834-6.632-4.552-10.618a59.746,59.746,0,0,0,4.285-17.381l16.915,20.665,4.21,18.034Z",
    transform: "translate(-1531.359 -456.871)",
    fill: "#0b1320",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M1598.9,599.54s-3.57,5.473,3.165,8.92,13.519,4.679,9.877,10.9c0,0,3.47-4.882-7.279-7.124C1592.3,609.656,1598.9,599.54,1598.9,599.54Z",
    transform: "translate(-1515.71 -536.783)",
    fill: "#0b1320",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1692.2,558.645s4.564,8.876,5.8,15.932c0,0,11.018.258,14.627-10.381l-6.035-15.488Z",
    transform: "translate(-1587.711 -498.284)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 20.837,
    height: 111.566,
    transform: "translate(88.701 115.884)",
    fill: "#3b2bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M1658.932,966.8l-5.145,86.091h31.525l-9.56-86.091Z",
    transform: "translate(-1558.616 -814.94)",
    fill: "#40cecf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M1679.662,614.325l4.431.5s-8.567,26.376-9.073,38.471-1.508,46.534-1.508,46.534h-16.819s-5.861-45.863-5.861-49.223,14.343-31.067,14.343-31.067Z",
    transform: "translate(-1556.379 -547.984)",
    fill: "#ff4f78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M1605.788,802.206s5.712,4.6,16.3,4.6c0,0-3.31-72.74-3.035-112.73.068-10.174.371-17.941,1.02-21.417,3.191-17.133,10.992-40.656,10.992-40.656s-1.132.557-2.821,1.43h0c-2.643,1.364-6.648,3.509-9.8,5.524a11.358,11.358,0,0,0-5.107,7.849c-1.172,7.607-3.714,22.881-4.586,27.482-1.176,6.216.91,43.881.91,43.881Z",
    transform: "translate(-1522.263 -561.373)",
    fill: "#5846f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M1644.478,694.076c.069-10.174.371-17.94,1.02-21.417C1648.689,655.526,1656.49,632,1656.49,632s-1.132.557-2.821,1.43h0c-.137.2-9.779,14.342-9.814,15.343s.842,16.365.842,16.365-4.436,8.765-5.262,12.411C1638.8,680.39,1642.71,689.957,1644.478,694.076Z",
    transform: "translate(-1547.695 -561.374)",
    fill: "#3b2bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M1717.689,585.936a42.973,42.973,0,0,1-16.653,6.888l2.323,8.736a3.516,3.516,0,0,0,3.727,2.994c4.835-.348,13.477-2.245,15.034-11.226Z",
    transform: "translate(-1594.403 -526.48)",
    fill: "#ff4f78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M1792.337,688.349s-5.721,5-19.16,10.549c0,0,.163,1.639.458,4.54q.04.385.081.8c.461,4.54,1.192,11.679,2.087,20.256,1.814,17.375,4.311,40.648,6.623,60.153,0,0-1.085.715-3.022,1.828-6.853,3.946-24.357,8.383-42.17,8.513,0,0-.21,0-.521-7.489-.769-18.5-2.158-55.08-2.536-86.091-.084-6.853-.118-13.432-.085-19.489.081-14.651.552-26.214,1.667-31.08a199.86,199.86,0,0,1,9.056-28.939q.263-.663.5-1.251c1.1-2.69,1.808-4.212,1.825-4.249h0l4.163,2.292,14.848,8.172c.113.062.228.126.339.19a29.151,29.151,0,0,1,2.935,1.9,29.542,29.542,0,0,1,10.178,13.463c1,2.687,2.124,5.535,3.268,8.478C1787.649,663.177,1792.9,677.151,1792.337,688.349Z",
    transform: "translate(-1619.433 -549.554)",
    fill: "#5846f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M1734.131,681.921c4.934-3.684,7.7-13.227,7.7-13.227l-3.551-13.653s15.458-16.321,15.924-17.161c.369-.667-1.9-13.787-2.856-19.189l-4.163-2.292a191.7,191.7,0,0,0-11.386,34.44C1734.686,655.707,1734.213,667.268,1734.131,681.921Z",
    transform: "translate(-1619.473 -549.556)",
    fill: "#3b2bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M1837.486,695.318s-12.072,11.157-14.4,21.717,0,29.032,0,29.032S1818.954,714.644,1837.486,695.318Z",
    transform: "translate(-1686.054 -609.325)",
    fill: "#3b2bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M1632.706,487.893s-1.039,8.361.662,11.206,1.7-10.486,1.7-10.486Z",
    transform: "translate(-1542.412 -452.223)",
    fill: "#352d29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M1635.855,460.036s-3.582,21.558,3.523,27.482a10.255,10.255,0,0,0,2.614,1.576c4.979,2.072,11.253-.218,16.063-6.738,5.737-7.774,5.606-20.778,5.606-20.778l-12.243-9.841-.521.125-8.948,2.112Z",
    transform: "translate(-1544.353 -424.838)",
    fill: "#f9a880"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1634.554,460.424a72.267,72.267,0,0,0-1.12,8.162,55.04,55.04,0,0,0-.168,6.435c.177,4.856,1.951,10.5,4.81,12.884a10.252,10.252,0,0,0,2.614,1.576c4.866,1.4,11.017-1.731,15.453-7.744,5.738-7.774,9.852-18.761,9.852-18.761l-16.4-10.727-8.948,2.112Z",
    transform: "translate(-1543.052 -425.227)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M1650.754,567.222l5.04.9a4.255,4.255,0,0,1-2.29,3.1C1651.508,572.12,1650.754,567.222,1650.754,567.222Z",
    transform: "translate(-1556.32 -512.306)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M1670.165,417.169s7.19-7.079,19.943-1.311c9.278,4.195,9.779,12,9.779,12l-16.37-8.248Z",
    transform: "translate(-1571.024 -395.951)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M1668.42,431.363a9.766,9.766,0,0,0,1.661.127s3.643-1.1,4.237.955.243,13.307,11.719,17.327v.25l.069,6.914s12.468-3.83,11.832-17.539-12.016-15.05-12.016-15.05-5.654-8.856-15.654-.724C1663.074,429.477,1666.137,430.978,1668.42,431.363Z",
    transform: "translate(-1567.7 -400.943)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M1676.729,498.768a7.6,7.6,0,0,1-1.409-.363c-.492-.159-.989-.314-1.423-.441s-.938-.267-1.439-.4a7.494,7.494,0,0,1-1.375-.454c-.35-.181-.433-.429.094-.548a7.212,7.212,0,0,1,3.115.353,6.639,6.639,0,0,1,2.734,1.364C1677.359,498.652,1677.126,498.807,1676.729,498.768Z",
    transform: "translate(-1571.502 -458.743)",
    fill: "#383b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M1638.6,491.8a3.591,3.591,0,0,1-.891-.01c-.316-.029-.635-.053-.912-.069s-.6-.027-.915-.033a3.543,3.543,0,0,1-.885-.088c-.234-.073-.319-.25-.022-.445a3.516,3.516,0,0,1,1.909-.326,3.316,3.316,0,0,1,1.825.532C1638.966,491.584,1638.85,491.749,1638.6,491.8Z",
    transform: "translate(-1544.225 -454.439)",
    fill: "#352d29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M1644.942,530.072l-1.491,1.857s-.569-1.078.242-1.7a1.455,1.455,0,0,1,1.25-.157Z",
    transform: "translate(-1550.639 -484.112)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M1645,534.6l.064.011.838.117a.191.191,0,0,0,.2-.171c.019-.107-.041-.212-.126-.217l-.838-.117a.768.768,0,0,1-.578-.493,1.827,1.827,0,0,1-.1-1.062l.021-.115c.054-.3.252-.528.44-.5a.954.954,0,0,0,.816-.343,1.94,1.94,0,0,0,.473-.986l.285-1.636a.179.179,0,0,0-.127-.215.192.192,0,0,0-.2.173l-.285,1.635a1.476,1.476,0,0,1-.356.75.637.637,0,0,1-.54.235c-.367-.051-.74.328-.832.845l-.021.114a2.264,2.264,0,0,0,.13,1.317,1.082,1.082,0,0,0,.739.66Z",
    transform: "translate(-1551.274 -483.257)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 5.641,
    cy: 5.169,
    rx: 5.641,
    ry: 5.169,
    transform: "translate(99.925 51.09) rotate(-52.338)",
    fill: "#fca286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M1674.212,518.915a1.3,1.3,0,0,0,.817,1.645,1.338,1.338,0,0,0,1.451-1.158,1.3,1.3,0,0,0-.817-1.645A1.338,1.338,0,0,0,1674.212,518.915Z",
    transform: "translate(-1574.057 -474.826)",
    fill: "#383b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M1682.325,520.214a2.089,2.089,0,0,0,1.06-.491,4.161,4.161,0,0,1-.685.859C1682.4,520.814,1682.325,520.214,1682.325,520.214Z",
    transform: "translate(-1580.233 -476.33)",
    fill: "#383b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M1640.823,513.378c.006.818-.387,1.508-.879,1.541s-.9-.6-.9-1.421.387-1.508.879-1.541S1640.816,512.56,1640.823,513.378Z",
    transform: "translate(-1547.448 -470.448)",
    fill: "#383b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M1638.3,513.513a1.541,1.541,0,0,1-.716-.676,4.717,4.717,0,0,0,.376.989C1638.145,514.113,1638.3,513.513,1638.3,513.513Z",
    transform: "translate(-1546.341 -471.115)",
    fill: "#383b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1780.1,481.023c-1.987,2.58-6.182,3.331-7.713,2.359-1.983-1.259-4.4,1.463-7.326,2.425a5.488,5.488,0,0,1-5.733-1.307,8.842,8.842,0,0,1-1.876-2.213c-2.477-4.234.48-8.5-5.99-12.014-7.6-4.124-6.325-17.442-6.325-17.442l-1.151-8.9-3.375-26.093c10.068-1.56,16.467,8.649,18.8,20.459s-2.886,14.777,13.834,28.286C1781.84,473.521,1782.2,478.3,1780.1,481.023Z",
    transform: "translate(-1624.38 -399.04)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M1745.879,480.46s7.709-6.833,6.465-14.548C1752.341,465.911,1752.081,474.533,1745.879,480.46Z",
    transform: "translate(-1628.367 -435.574)",
    fill: "#2a4368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M1724.143,468.872s9.389-4.369,10.47-12.113C1734.615,456.759,1731.825,464.945,1724.143,468.872Z",
    transform: "translate(-1611.904 -428.643)",
    fill: "#2a4368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M1676.675,456.306a9.751,9.751,0,0,0,1.661.127s3.643-1.1,4.237.955.244,13.307,11.719,17.327v.249c.981-.056.822-.415-1.508-1.3-8.282-3.166-7.435-15.033-9.359-18.615s-5.467-1.066-5.467-1.066Z",
    transform: "translate(-1575.954 -425.887)",
    fill: "#0b1320",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1793.98,544.938c-1.987,2.58-6.181,3.331-7.713,2.359-1.983-1.258-4.4,1.463-7.326,2.425-1.795-.11-3.006-.281-3.006-.281l-4.6-3.239c-2.477-4.234.48-8.5-5.99-12.014-7.6-4.124-6.325-17.442-6.325-17.442h0a17.016,17.016,0,0,0,5.14-8.135l1.859-6.548s-6.9,23.187,8.275,30.712C1788.162,539.649,1795.412,540.807,1793.98,544.938Z",
    transform: "translate(-1638.258 -462.955)",
    fill: "#0b1320",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M1741.471,526.728s2.878-3.216,5.856-.589.442,8.307-3.377,9.928-5.4-2.413-5.4-2.413Z",
    transform: "translate(-1622.816 -480.409)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M1752.292,543.991a.465.465,0,0,1-.254-.244l-1.149-2.532,3.749-2a.472.472,0,0,1,.662.215.548.548,0,0,1-.244.7l-2.845,1.518.734,1.62a.548.548,0,0,1-.246.7.486.486,0,0,1-.407.027Z",
    transform: "translate(-1632.164 -491.048)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M1637.975,426.048s-2.7-4.885-3.632.754-2.228,10.433-7.5,11.734c0,0,1.669-1.055,1.707-2.257a24.62,24.62,0,0,1-6.659,2.578s-3.667-3.422-.195-12.041a9.463,9.463,0,0,0-2.472,3.793s4.487-13.452,17.49-13.844Z",
    transform: "translate(-1532.441 -398.35)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M1650.224,434.349s-7.713,2.423-10.915,14.566C1639.313,448.915,1644.659,436.411,1650.224,434.349Z",
    transform: "translate(-1547.653 -411.67)",
    fill: "#2a4368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M1647.018,429.089a14.736,14.736,0,0,0-9.389,10.132S1641.453,431.151,1647.018,429.089Z",
    transform: "translate(-1546.382 -407.685)",
    fill: "#2a4368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M1728.012,559.364l-.034.017s11.407-.745,6.006-13.944-2.727-17.19-2.727-17.19l-2.33-2.684s-.26.557-.633,1.514c-1.527,3.93-4.946,14.606-.068,21.152,5.535,7.426.763,10.586-.116,11.082-.019.012-.038.021-.057.031A.231.231,0,0,0,1728.012,559.364Z",
    transform: "translate(-1613.082 -480.754)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M1728.109,564.036c6.977-3.681,2.784-10.67.472-15.372-2.327-4.729-.191-16.516-.191-16.516l-.1-.343c-1.527,3.93-4.946,14.606-.069,21.153C1733.756,560.381,1728.986,563.54,1728.109,564.036Z",
    transform: "translate(-1613.083 -485.48)",
    opacity: 0.6,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M1792.417,501.772s-4.24,12.616,1.061,17.414,9.2,5.176,13.179,13.814c0,0-1.664-6.4-13.317-12.61C1782.349,514.539,1792.417,501.772,1792.417,501.772Z",
    transform: "translate(-1660.424 -462.735)",
    fill: "#0b1320",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M1961.242,724.858s12.646,1.063,20.987,9.706C1982.227,734.563,1969.48,738.14,1961.242,724.858Z",
    transform: "translate(-1791.484 -631.698)",
    fill: "#3b2bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M1971.926,626.73a11.054,11.054,0,0,1-2.351,2.262,62.828,62.828,0,0,1-6.978,3.4l-1.811,2.044-13.179,37.35-9.337-22.944,12.332-20.179s1.2-22.047,3.735-22.261c2.187-.182,3.7,7.465,4.084,9.577.051.335.086.534.086.534s7.625,2.673,7.486,10.086C1966,626.593,1969.9,625.463,1971.926,626.73Z",
    transform: "translate(-1774.086 -541.975)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M2030.363,589.742s-5.1,12.111-9.929,17.808a11.05,11.05,0,0,1-2.351,2.262,62.82,62.82,0,0,1-6.978,3.4l-1.811,2.044-6.982-20.894,4.523,2.551s.035-.041.1-.118c1.179-1.4,12.593-14.915,16.559-14.726a.184.184,0,0,1,.161.265l-1.84,3.644c.28-.3,4.568-4.808,6.683-4.906a.519.519,0,0,1,.5.65l-1.406,2.387s2.163-1.28,2.965-.358c.783.9-7.013,10.623-7.177,10.92C2023.379,594.668,2028.8,587.952,2030.363,589.742Z",
    transform: "translate(-1822.59 -522.794)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M2024.8,652.3s2.228,6,.857,10.113C2025.652,662.408,2025.81,654.767,2024.8,652.3Z",
    transform: "translate(-1839.618 -576.741)",
    fill: "#f9a880"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M2048.109,627.762s6.255,4.371,8.142,7.713Z",
    transform: "translate(-1857.276 -558.161)",
    fill: "#f9a880"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M1930.478,734.563s-2.591,44.716-36.893,51.927l-.67-34.137,16.576-27.5a20.139,20.139,0,0,0,3.066,3.444,23.673,23.673,0,0,0,13.624,6.189,25.2,25.2,0,0,0,4.3.073Z",
    transform: "translate(-1739.734 -631.698)",
    fill: "#5846f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M1861.365,973.727s-6.807,1.331-10.991-1.657C1850.373,972.069,1855.424,977.976,1861.365,973.727Z",
    transform: "translate(-1707.512 -818.936)",
    fill: "#3b2bc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 2.294,
    height: 4.588,
    transform: "translate(122.46 35.874) rotate(3)",
    fill: "#7e8a9c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 225.503,
    height: 290.597,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M0,0S5.013,2.086,8.858,2.086A11.494,11.494,0,0,0,15.38,0V.961a10.424,10.424,0,0,1-6.185,1.9C5.35,2.86,0,.961,0,.961Z",
    transform: "translate(108.7 57.325) rotate(-37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M7.267,0,8.1,2.248A22.18,22.18,0,0,1,5.388,3.626a14.646,14.646,0,0,1-2.534.919c-.751.18-2.5.526-2.814-.919S1.3,1.708,1.3,1.708,2.792,1.376,4.284.949,7.267,0,7.267,0Z",
    transform: "translate(102.559 54.533) rotate(14)",
    fill: "#5b5682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M7.83.006a7.57,7.57,0,0,1,7.529,7.881c-.284,4.133-3.6,7.722-7.41,8S-.269,12.99.013,8.853,3.7.189,7.83.006Z",
    transform: "matrix(-0.934, 0.358, -0.358, -0.934, 133.079, 52.761)",
    fill: "#bac7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M7.43.018C11.241-.264,14.1,2.861,13.821,7s-3.6,7.718-7.411,8S-.263,12.155.019,8.018,3.619.3,7.43.018Z",
    transform: "matrix(-0.934, 0.358, -0.358, -0.934, 133.448, 52.723)",
    fill: "#d3deef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M4.76.011C7.2-.169,9.035,1.833,8.855,4.483A5.5,5.5,0,0,1,4.106,9.609C1.664,9.789-.169,7.787.012,5.14A5.5,5.5,0,0,1,4.76.011Z",
    transform: "matrix(-0.934, 0.358, -0.358, -0.934, 130.16, 51.095)",
    fill: "#97a6bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M601.092,2210.349s3.6-3.275,10.654-2.941,14.329,6.869,14.8,13.611-1.459,7.41-2.756,7.754-3.555-1.142-3.442-3.847c-.124-2.68-.069-8.58-5.054-12.771s-14.935-1.261-14.935-1.261Z",
    transform: "translate(-499.799 -2191.937)",
    fill: "#bac7db"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M4.285,3.058C-2.978,9.128-.955,21.671,9.95,22.48S42.461,18.7,37.464,9.532,11.548-3.011,4.285,3.058Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 1588.865, 772.615)",
    fill: "#d7dbe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M3.7,9.128c-7.263,6.069-2.239,7.962,1.54,8.188s14.333-4.108,24.721-5.472c14.506-1.9,30.1-1.837,27.139-7.272C54.5-.193,40.9-.988,27.072,1.056S7.187,6.214,3.7,9.128Z",
    transform: "translate(1795.392 851.317) rotate(111)",
    fill: "#d7dbe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M345.717,1096.239c10.114-1.328,7.626-8.947-2.015-7.522S338.474,1097.19,345.717,1096.239Z",
    transform: "translate(2777.452 1439.391) rotate(135)",
    fill: "#d7dbe6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistant);
export default __webpack_public_path__ + "static/media/assistant.cd9eb241.svg";
export { ForwardRef as ReactComponent };